import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { projectId, publicAnonKey as fallbackAnonKey } from '/utils/supabase/info';

// Support environment variables for deployment flexibility
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || `https://${projectId}.supabase.co`;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || fallbackAnonKey;

// Singleton instance
let supabaseInstance: SupabaseClient | null = null;

/**
 * Get the singleton Supabase client instance
 * This ensures only one client is created across the entire app
 */
export function getSupabaseClient(): SupabaseClient {
  if (!supabaseInstance) {
    supabaseInstance = createClient(supabaseUrl, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        // Increase lock timeout to prevent "lock not released" warnings
        // Especially important with React Strict Mode double-mounting
        storageKey: 'sb-efmmesrjbwzyjooxvvop-auth-token',
        storage: {
          getItem: (key) => {
            return localStorage.getItem(key);
          },
          setItem: (key, value) => {
            localStorage.setItem(key, value);
          },
          removeItem: (key) => {
            localStorage.removeItem(key);
          },
        },
      },
      global: {
        headers: {
          'X-Client-Info': 'supabase-js-web',
        },
      },
    });
  }
  return supabaseInstance;
}

// Export API URL for convenience
export const API_URL = import.meta.env.VITE_API_URL || `https://${projectId}.supabase.co/functions/v1/make-server-355b1994`;
export { projectId };
export const publicAnonKey = anonKey;
